export const sideBarColumnsFilters = () => {
  return {
    toolPanels: ["columns", "filters"],
  };
};
